import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { format, eachDayOfInterval, isToday } from "date-fns";
import { ChevronLeft, ChevronRight } from "styled-icons/boxicons-regular";
import { Col } from "styled-bootstrap-grid";
import styled from "styled-components";
//import { data } from "./data";
import { withTranslation, Trans } from "react-i18next";
//import {dateFormat} from "../../../../../Api/Utils/ReuseableFunctions";
import { getShiftWiseEmployees } from "../../../../../Actions/shiftWiseEmployees";

class ShiftView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weekStart: undefined,
      weekEnd: undefined,
      weekDataValues: undefined,
      formDataOpen: false,
      employeeData: undefined,
      otherData: "",
      heightSet: 0,
      shiftWiseData: undefined
    };
    this.days = [];
    this.weekContainer = this.weekContainer.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  componentDidMount() {
    this.props.dispatch(getShiftWiseEmployees({
      ssoId: this.props.ssoId,
      workshopLocation: this.props.userDefault.branchId,
      role: this.props.userDefault.emplRole,
      startDate: format(this.props.startDate, "dd/MM/yyyy"),
      endDate: format(this.props.endDate, "dd/MM/yyyy")
    }));
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        weekStart: this.props.startDate,
        weekEnd: this.props.endDate,
        shiftWiseData: this.props.shiftWiseData.shiftViewList
      });
      this.updateDimensions();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
    this.setState({ heightSet: document.body.scrollHeight - 297 + "px" });
  }

  weekView = () => {
    //const { weekStart, weekEnd } = this.state;
    return (
      <ParentDiv>
        <ButtonLeft
          type="submit"
          onClick={() => {
            this.props.weekAction("previous");
          }}
        >
          {" "}
          <Caretleft size="24" />
        </ButtonLeft>
        <span>
          {format(this.state.weekStart, "dd")}{" "}
          <Trans>{format(this.state.weekStart, "MMM").toLowerCase()}</Trans> -{" "}
          {format(this.state.weekEnd, "dd")}{" "}
          <Trans>{format(this.state.weekEnd, "MMM").toLowerCase()}</Trans>{" "}
          {format(this.state.weekEnd, "yyyy")}
        </span>
        <ButtonRight
          type="submit"
          onClick={() => {
            this.props.weekAction("next");
          }}
        >
          <Caretright size="24" />
        </ButtonRight>
        <MainApp>{this.weekContainer()}</MainApp>
      </ParentDiv>
    );
  };
  weekContainer() {
    const { weekStart, weekEnd, heightSet } = this.state;
    var array = eachDayOfInterval({ start: weekStart, end: weekEnd });
    //var isWeekData = true;
    //var updatedHt = this.state.heightSet - 285;
    // const empDivStyle = {
    //   maxHeight: updatedHt + "px"
    // };
    return (
      <>
        <WeekdaysDiv>
          <InnerDiv>

            {array.map(days => (
              <WeekDaysName md="=2" key={days}>
                <WeekDays>
                  <WeekDate value={isToday(days)}>
                    {format(days, "dd")}{" "}
                  </WeekDate>
                  <Trans>{format(days, "eee").toLowerCase()}</Trans>{" "}
                </WeekDays>
              </WeekDaysName>
            ))}

          </InnerDiv>
          <InnerContentDiv maxHeight={heightSet}>
            {this.state.shiftWiseData.map((shiftDaysDataValue, index) => {
              return <React.Fragment key={index}><DivHeader>
                <Col md="12">
                  {shiftDaysDataValue.shiftName} | {shiftDaysDataValue.shiftTiming}
                </Col>
              </DivHeader>

                <DivBottom>
                  <AllEmployeeDataDiv>
                    {shiftDaysDataValue.shiftDateDetailsList.map((shiftDays, i) => {
                      return <ColDiv md={2} key={i}>
                        {shiftDays.employeeList.map((data, index) => {
                          return <EmployeeDataDiv key={index}> {data.employeeName}</EmployeeDataDiv>
                        })}
                      </ColDiv>
                    })}
                  </AllEmployeeDataDiv>
                </DivBottom>
              </React.Fragment>
            })
            }
          </InnerContentDiv>
        </WeekdaysDiv>
        <FooterData>
          <Button onClick={this.props.BackTab}>
            <Trans>back</Trans>
          </Button>
        </FooterData>
      </>
    );
  }

  render() {
    return (
      <>{this.state.shiftWiseData !== void 0 ? this.weekView() : <div />}</>
    );
  }
}

const mapStateToProps = ({
  auth,
  userMessage,
  managerTimesheetData,
  shiftWiseEmployees
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    weekData: managerTimesheetData.payload.weekDataDetails,
    shiftData: managerTimesheetData.payload.shiftList,
    shiftWiseData: shiftWiseEmployees.shiftViewList
  };
};

export default withRouter(
  connect(
    mapStateToProps
  )(withTranslation()(ShiftView))
);

const ParentDiv = styled.div`
  padding-top: 3px;
  font-size: 16px;
  width: 100%;
  text-align: center;
`;
const MainApp = styled.div`
  position: relative;
  height: 100vh;
  padding-top:23px
`;
const WeekdaysDiv = styled.div``;
const InnerDiv = styled.div`    
  padding-left: 5%;
  padding-right: 5%;`;
const InnerContentDiv = styled.div`
  border-radius:2px solid #e8e8e8;;
  padding-left: 5%;
  padding-right: 5%;
  max-height:${props => props.maxHeight ? props.maxHeight : "360px"}
  overflow-y: scroll;
`;
const WeekDaysName = styled(Col)`
  position: relative;
  min-height: 1px;
  display: inline-table;
  flex: 0 0 14.28% !important;
  max-width: 14.28% !important;
  padding: 4px 3% 4px 3%;
`;
const WeekDays = styled.div`
  display: flex;
  position: relative;
`;
const WeekDate = styled.div`
  background: ${props => (props.value ? "#70b0f3" : "#FFFFFF")};
  color: ${props => (props.value ? "#FFFFFF" : "#000000")};
  margin-right: 10px;
  top: 1px;
  border-radius: 20px;
  height: 24px;
  width: 24px;
  padding-right: 1px;
  padding-top: 1px;
`;
const DivHeader = styled.div`
  background: #dee2e669;
  text-align: left;
  height: 35px;
  padding-top: 6px;
  border-radius: 2px;
  border: 1px solid #dee2e669;
`;
const DivBottom = styled.div``;
const AllEmployeeDataDiv = styled.div`
  text-align:left;
  display:flex;
`;
const ColDiv = styled(Col)`
  border: 1px solid #8080801c;
  flex: 0 0 14.28% !important;
  max-width: 14.28% !important;
`;
const EmployeeDataDiv = styled.div`
  line-height: 35px;
  background: #ffffff;
`;
const Caretleft = styled(ChevronLeft)`
  position: relative;
  right: 8px;
  bottom: 4px;
  background: #b7b7b7;
  border-radius: 20px;
`;
const Caretright = styled(ChevronRight)`
  position: relative;
  right: 8px;
  bottom: 4px;
  background: #b7b7b7;
  border-radius: 20px;
`;
const ButtonLeft = styled.button`
  position: relative;
  right: 17px;
  top: 2px;
  border-radius: 20px;
  height: 24px;
  width: 24px;
`;
const ButtonRight = styled.button`
  position: relative;
  left: 17px;
  top: 2px;
  border-radius: 20px;
  height: 24px;
  width: 24px;
`;
const Button = styled.button`
  background: #ffffff;
  border-radius: 30px;
  padding: 0;
  border: 1px solid #96989a;
  height: 34px;
  width: 129px;
  position: relative;
  left: 8px;
  color: #000000;
  border: 1px solid #95989a;
  font-size: 12px;
`;
const FooterData = styled.div`
  border-top: 1px solid #babec3;
  background: #f1f4f9;
  height: 70px;
  padding-top: 15px;
  text-align: center;
  position: fixed;
  bottom: 0;
  right: 0px;
  width: 101%;
  margin-left: 4px;
`;